module.exports = __webpack_public_path__ + "img/icon_map_4_off_010.9cbf5ea5.png";